export const legacyRedirects = [
  {
    from: "/Privacy",
    to: "/privacy",
  },
  {
    from: "/Terms",
    to: "/terms",
  },
  {
    from: "/Contact",
    to: "/contact",
  },
  {
    from: "/Download",
    to: "/download",
  },
  {
    from: "/DownloadRedirect",
    to: "/download-redirect",
  },
];

const routes = [
  {
    path: "/",
    exact: true,
    component: "Home",
  },
  {
    path: "/Privacy",
    exact: true,
    component: "Privacy",
  },
  {
    path: "/privacy",
    exact: true,
    component: "Privacy",
  },
  {
    path: "/Terms",
    exact: true,
    component: "Terms",
  },
  {
    path: "/terms",
    exact: true,
    component: "Terms",
  },
  {
    path: "/child-safety-standards",
    exact: true,
    component: "ChildSafetyStandards",
  },
  {
    path: "/download",
    exact: true,
    component: "Download",
  },
  {
    path: "/Download",
    exact: true,
    component: "Download",
  },
  {
    path: "/download-redirect",
    exact: true,
    component: "DownloadRedirect",
  },
  {
    path: "/DownloadRedirect",
    exact: true,
    component: "DownloadRedirect",
  },
  {
    path: "/contact",
    exact: true,
    component: "ContactUs",
  },
  {
    path: "/Contact",
    exact: true,
    component: "ContactUs",
  },
  {
    path: "/indian-dating-in-uk",
    exact: true,
    component: "IndianDatingUKBlog",
  },
  {
    path: "/indian-dating-in-europe",
    exact: true,
    component: "IndianDatingEuropeBlog",
  },
  {
    path: "/indian-dating-in-usa",
    exact: true,
    component: "IndianDatingUSBlog",
  },
  {
    path: "/indian-dating-in-canada",
    exact: true,
    component: "IndianDatingCanadaBlog",
  },
  {
    path: "/indian-dating-in-australia",
    exact: true,
    component: "IndianDatingAustraliaBlog",
  },
  {
    path: "*",
    exact: false,
    component: "NotFound",
  },
];

export default routes;
